import type { AbstractCtaProps, CtaRefType } from '../../../util/cta/cta.data';

export type PrimaryButtonRef = CtaRefType;

export const buttonSizes = ['medium'] as const;
export const defaultButtonSize: ButtonSize = 'medium';

export const colorVariations = ['dark7'];
export type ColorVariation = (typeof colorVariations)[number];

export type ButtonSize = (typeof buttonSizes)[number];

export type PrimaryButtonProps = {
  icon?: string;
  size?: ButtonSize;
  hasOutline?: boolean;
  revertColor?: boolean;
  isSelected?: boolean;
  noTransition?: boolean;
  colorVariation?: ColorVariation;

  // todo: maybe refactor transition-component and add as default option?
  disableTriggerInOnScroll?: boolean;
} & AbstractCtaProps;
